module.exports = __webpack_public_path__ + "static/media/drip_symbol.395dcd58.svg";